var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HealthCare2u_-_Logo",
    "data-name": "HealthCare2u - Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125.632,
    height: 61.303,
    viewBox: "0 0 125.632 61.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Left_Square",
    "data-name": "Bottom Left Square",
    width: 21.796,
    height: 21.776,
    transform: "translate(32.135 39.527)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Left_Square",
    "data-name": "Top Left Square",
    width: 21.796,
    height: 21.775,
    transform: "translate(32.135)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bottom_Right_Square",
    "data-name": "Bottom Right Square",
    width: 21.797,
    height: 21.776,
    transform: "translate(71.699 39.527)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top_Right_Square",
    "data-name": "Top Right Square",
    width: 21.797,
    height: 21.775,
    transform: "translate(71.699)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H1",
    d: "M416.488,157.676h2.167v2.515h4.569v-2.515h2.167v7.061h-2.167v-2.673h-4.569v2.673h-2.167Z",
    transform: "translate(-416.488 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E1",
    d: "M424.009,157.676h7.732v1.638h-5.564v1.132h5.272v1.463h-5.272v1.132h5.691v1.7h-7.858Z",
    transform: "translate(-412.665 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A1",
    d: "M434.1,157.676h2.822l3.885,7.061H438.4l-.673-1.249H433.33l-.635,1.249h-2.421Zm.039,4.292h2.772l-1.406-2.654Z",
    transform: "translate(-409.48 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M438.416,157.676h2.167v5.247h4.872v1.814h-7.039Z",
    transform: "translate(-405.342 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M443.278,157.676h8.26v1.756h-3.047v5.306h-2.167v-5.306h-3.045Z",
    transform: "translate(-402.87 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "H2",
    d: "M450.028,157.676H452.2v2.515h4.569v-2.515h2.167v7.061h-2.167v-2.673H452.2v2.673h-2.167Z",
    transform: "translate(-399.439 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M457.445,160.18c0-2.069,1.163-2.556,3.115-2.556h2.549c3.085,0,3.486.663,3.466,2.663h-2.169v-.2c0-.506-.369-.652-1.015-.652h-2.362c-1.142,0-1.358.536-1.358,1.413v.761c0,1.025.216,1.415,1.24,1.415h2.314c.977,0,1.27-.1,1.27-.976h2.167v.663c0,1.19-.43,2.128-2.606,2.128h-3.5c-1.952,0-3.115-.488-3.115-2.556Z",
    transform: "translate(-395.669 -130.024)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A2",
    d: "M468.438,157.676h2.821l3.885,7.061h-2.412l-.673-1.249h-4.394l-.633,1.249H464.61Zm.038,4.292h2.774l-1.406-2.654Z",
    transform: "translate(-392.027 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M472.752,157.676h6.541c1.67,0,2.119.829,2.119,2.1v.449c0,.946-.216,1.5-1.211,1.736v.02c.644.118,1.181.4,1.181,1.561v1.2h-2.168v-.848c0-.741-.214-.986-.888-.986h-3.407v1.834h-2.167Zm2.167,3.472H478.5c.585,0,.8-.234.8-.741v-.234c0-.625-.314-.741-1-.741h-3.388Z",
    transform: "translate(-387.888 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E2",
    d: "M480.111,157.676h7.733v1.638h-5.566v1.132h5.272v1.463h-5.272v1.132h5.692v1.7h-7.86Z",
    transform: "translate(-384.148 -129.998)",
    fill: "#0d123b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": 2,
    d: "M486.8,160.307c0-.868.567-1.444,1.964-1.542l2.478-.157c1.582-.1,1.689-.127,1.689-.818,0-.576-.057-.7-1.445-.7h-1.434c-.917,0-1.2.136-1.2.868v.3H486.8v-.829c0-1.394.82-1.863,2.774-1.863h2.851c2.03,0,2.558.6,2.558,2.078,0,2.076-.382,2.428-2.91,2.565l-2.237.118c-.906.048-1.044.223-1.044.857h6.288v1.522H486.8Z",
    transform: "translate(-380.746 -131.067)",
    fill: "#9e3223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M493.878,157.676h2.167v4.076c0,.9.321,1.249,1.21,1.249H499.4c.888,0,1.211-.351,1.211-1.249v-4.076h2.167v4.545c0,1.755-.908,2.595-2.9,2.595h-3.1c-1.992,0-2.9-.839-2.9-2.595Z",
    transform: "translate(-377.15 -129.998)",
    fill: "#0d123b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.22d1f1fe959ada8bed5ae7ceb14f2082.svg";
export { ForwardRef as ReactComponent };